import {
  configureStore as createStore,
  combineReducers,
} from '@reduxjs/toolkit';
import { domainRegistry } from './domainRegistry';
import { StoreConfig } from './types';
import { apiErrorMiddleware } from './middleware';

export const configureStore = (config?: Partial<StoreConfig>) => {
  const domains = config?.domains || domainRegistry;

  const reducers = domains.reduce(
    (acc, domain) => {
      acc[domain.name] = domain.reducer;
      return acc;
    },
    {} as Record<string, any>
  );

  const rootReducer = combineReducers(reducers);

  const middleware = domains
    .filter(domain => domain.middleware && domain.middleware.length > 0)
    .flatMap(domain => domain.middleware || []);

  return createStore({
    reducer: rootReducer,
    preloadedState: config?.preloadedState,
    middleware: getDefaultMiddleware =>
      getDefaultMiddleware({
        serializableCheck: false,
      })
        .concat(middleware)
        .concat(apiErrorMiddleware), // Add API error middleware
  });
};
